export default "__VITE_ASSET__BGLfcbMZ__"